import React, { useState, useEffect, useRef } from 'react'

export default function StyledFileInput({ onChange, name, value }) {
  return (
    <div>
      <input
        name={name}
        className="relative m-0 block w-full  min-w-0 flex-auto rounded border border-solid border-blue-gray-200 bg-clip-padding px-3 py-[0.32rem] text-xs font-normal text-stone-500 transition duration-300 ease-in-out file:-mx-3 file:-my-[0.32rem] file:overflow-hidden file:rounded-none file:border-0 file:border-solid file:border-inherit file:bg-neutral-100 file:px-3 file:py-[0.32rem] file:text-stone-500 file:transition file:duration-150 file:ease-in-out file:[border-inline-end-width:1px] file:[margin-inline-end:0.75rem] hover:file:bg-neutral-200 focus:border-primary focus:text-stone-500 focus:shadow-te-primary focus:outline-none"
        type="file"
        accept="application/pdf, image/png, image/jpeg, image/gif, image/jpg"
        onChange={onChange}
      />
    </div>
  )
}
